import { RootState } from "@/state/reducer";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Greeting from "./pages/greeting";
import TestStepOne from "./pages/testStepOne";
import TestStepTwo from "./pages/testStepTwo";
import TestStepThree from "./pages/testStepThree";
import Complete from "./pages/complete";
import { mtexts } from "./testmoderation";
import { getTextModerationResult } from "./utils";
import { APP_VERSION, serverUrl } from "./config/default";

const App = () => {
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();

  // Сколько тестов прошёл авторизованный пользователь (для пометки внизу)
  const [testsPassed, setTestsPassed] = useState<number | null>(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setTestsPassed(null);
      return;
    }
    fetch(`${serverUrl}tests/count`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (data && typeof data.count === "number") {
          setTestsPassed(data.count);
        }
      })
      .catch(() => {});
    // обновляем при смене экрана — например, после завершения теста
  }, [State.selectedTab]);

  /* useEffect(() => {
    for (let t of mtexts) {
    const moderation = getTextModerationResult(t);
    console.log("Moderation:", moderation);
   }
  }, []) */

  const page = (() => {
    switch (State.selectedTab) {
      case "step1":
        return <TestStepOne />;
      case "step2":
        return <TestStepTwo />;
      case "step3":
        return <TestStepThree />;
      case "finish":
        return <Complete />;
      default:
        return <Greeting />;
    }
  })();

  return (
    <div className="app">
      {page}
      {testsPassed !== null && (
        <div className="testsPassed">Пройдено тестов: {testsPassed}</div>
      )}
      <div className="version">v{APP_VERSION}</div>
    </div>
  );
};

export default App;
